<template>
  <div class="limiter">
    <div class="container-login100">
      <div class="wrap-login100 p-t-85 p-b-20">
        <div class="login100-form validate-form">
          <span>
            <center>
              <img v-bind="mainProps" src="@/assets/img/ff.png" alt="AVATAR" />
            </center>
          </span>

          <ol>
            <li>One lowercase letter required</li>
            <li>One uppercase letter required</li>
            <li>8 characters minimum</li>
            <li>One number required</li>
          </ol>

          <div>
            <div
              class="wrap-input100 validate-input m-t-85 m-b-35"
              data-validate="New Password"
            >
              <p>Enter new password</p>
              <input
                v-model="pw"
                class="input100"
                type="password"
                name="newPassword"
              />
            </div>
            <p v-if="error.pw">
              <span class="danger-new">{{ this.error.pw }}</span>
            </p>
          </div>

          <div>
            <div
              class="wrap-input100 validate-input m-b-50"
              data-validate="Confirmation Password"
            >
              <p>Retype new password</p>
              <input
                v-model="retypePW"
                class="input100"
                type="password"
                name="confirmationPass"
              />
            </div>
            <p v-if="error.retype">
              <span class="danger-new">{{ this.error.retype }}</span>
            </p>
          </div>

          <div class="container-login100-form-btn">
            <button class="login100-form-btn" @click="submitPW">SUBMIT</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NotificationTemplate from "@/pages/Notifications/NotificationTemplate";
import Failed from "@/pages/Notifications/Failed";
export default {
  data() {
    return {
      mainProps: { width: 200, height: 200, class: "m1" },
      pw: "",
      retypePW: "",

      error: {
        retype: "",
        pw: ""
      }
    };
  },

  methods: {
    submitPW() {
      this.error.retype = "";
      this.error.pw = "";
      this.checkForm();

      this.$store
        .dispatch("submitPW", {
          email: this.$route.query.email,
          password: this.pw,
          token: this.$route.query.token
        })
        .then(res => {
          if (res.data.response && res.data.response.code === 1) {
            this.$notify({
              component: NotificationTemplate,
              icon: "ti-check",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success"
            });
            this.$router.push("/login");
          } else {
            this.$notify({
              component: Failed,
              icon: "ti-close",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "danger"
            });
          }
        });
    },
    checkForm: function(e) {
      let val1 = /[a-z]+/;
      let val2 = /[A-Z]+/;
      let val3 = /.{8,}/;
      let val4 = /[0-9]+/;
      if (this.retypePW === this.pw) {
        if (
          val1.test(this.pw) &&
          val2.test(this.pw) &&
          val3.test(this.pw) &&
          val4.test(this.pw)
        ) {
          return true;
        } else {
          this.error.pw = "Incorrect password format.";
        }
      }
      this.error.retype = "";

      if (this.retypePW !== this.pw)
        this.error.retype = "Retype password not match.";
      e.preventDefault();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/main.css";
@import "../../assets/css/util.css";
</style>
